import React from 'react'
import BaseInput, { CommonInputProps } from './BaseInput'
import { useTranslation } from 'react-i18next'

interface PhoneInputProps extends CommonInputProps {
	value: string | undefined
	onChange?: (value: string) => void
}

const PhoneInput: React.FC<PhoneInputProps> = ({
	value,
	onChange,
	readonly,
}: PhoneInputProps): JSX.Element => {
	const { t } = useTranslation('common')

	const handleChange = (value: string | number | undefined) => {
		if (!onChange) return
		if (value) {
			onChange(value.toString())
		} else {
			onChange('')
		}
	}

	return (
		<BaseInput
			readonly={readonly}
			label={t('phone')}
			value={value}
			onChange={handleChange}
			type='tel'
		/>
	)
}

export default PhoneInput
